import { html, unsafeCSS } from 'lit';
import { customElement } from 'lit/decorators.js';
import style from './state-diversification.scss?inline';

import { PopBaseComponent } from '../../base/pop-base-component.js';
import { Constants } from './state-diversification.constants.js';
import type { StateDiversificationContentObject } from './state-diversification.model.js';

/**
 * @tag pop-state-diversification-component
 * @attribute { StateDiversificationContentObject } [data-component-object] StateDiversification content object
 */
@customElement(Constants.TAG_NAME)
export class PopStateDiversificationComponent extends PopBaseComponent {
  static get styles() {
    return [...super.styles, unsafeCSS(style)];
  }

  /**
   * @internal
   */
  tagName = Constants.TAG_NAME;

  /**
   * StateDiversification content object
   */
  componentObject?: StateDiversificationContentObject;

  private renderTopSection() {
    return html`
      <h3
        class="state-diversification-heading b-typography-serif--headline--100 b-font-weight-bold"
      >
        ${Constants.COMPONENT_TITLE}
      </h3>
    `;
  }

  private renderControlSection() {
    return html`
      <div
        class="state-diversification-controls b-margin-block-start--micro--jumbo"
      >
        ${this.renderAsOfDate()}
      </div>
    `;
  }

  private renderAsOfDate() {
    return html`
      <beacon-control>
        <label slot="label" for="${Constants.DATA_AS_OF_DROPDOWN_ID}">
          ${Constants.DATA_AS_OF_DROPDOWN_LABEL}
        </label>
        <select
          id="${Constants.DATA_AS_OF_DROPDOWN_ID}"
          @change="To be implemented in a future MR"
        >
          <option value="2022-01-01" selected>2022-01-01</option>
          <option value="2022-02-01">2022-02-01</option>
          <option value="2022-03-01">2022-03-01</option>
          <option value="2022-04-01">2022-04-01</option>
        </select>
      </beacon-control>
    `;
  }

  private renderTable() {
    return html`<div
      class="state-diversification-table b-margin-block-start--micro--jumbo"
    >
      <p>Table content goes here</p>
    </div>`;
  }

  private renderDisclaimerSection() {
    return html`<div class="b-margin-block-start--micro--jumbo">
      Disclaimer content goes here
    </div>`;
  }

  render() {
    return this.renderComponent(html`
      <section class="state-diversification-content b-container">
        ${this.renderTopSection()} ${this.renderControlSection()}
        ${this.renderTable()} ${this.renderDisclaimerSection()}
      </section>
    `);
  }
}
